import { defineStore } from 'pinia'

type PreloaderControllerStoreState = {
  text: string;
  bookingPortalSettlementModalVisible: boolean;
}


/**
 * Preloader Controller Store Definitions
 *
 * @returns {StoreDefinition}
 */
export const usePreloaderControllerStore = defineStore({
  id: 'preloaderController',

  actions: {
    updatePreloader(message: string) {
      this.text = message;
    },

    updateBookingPortalSettlementModalVisibility(isVisible: boolean) {
      this.bookingPortalSettlementModalVisible = isVisible;
    }
  },

  getters: {
    getMessage: (state) => state.text,
    isBookingPortalSettlementModalVisible: (state) => state.bookingPortalSettlementModalVisible,
  },

  state: () => {
    const preloaderControllerState: PreloaderControllerStoreState = {
      text: '',
      bookingPortalSettlementModalVisible: false,
    };

    return preloaderControllerState;
  }
});
